/**
 * Reinit OneTrust API on interior pageviews, based on Tealium.js
 */

export const loadOneTrust = () => {
    if(window.OneTrust !== undefined){
        setTimeout(() => {
            window.OneTrust.initializeCookiePolicyHtml();
        }, 250);
    }
};